import React, { useEffect, useRef, useState } from 'react';
import { IInvoicePaid } from '../Interfaces/IInvoicePaid';
import {
  alpha,
  IconButton,
  TableCell,
  TableRow,
  useTheme,
} from '@mui/material';
import { CustomeTextField } from '../generic/CustomeTextField';
import { Delete, Download, FindInPage, UploadFile } from '@mui/icons-material';
import { IDocument } from '../Interfaces/IDocument';
import { base64Download } from '../Document/DocumentRow';
import { getFetch } from '../hooks/useFetch';
import { useSelector } from 'react-redux';
import { State } from '../redux/mainReducer';
import { IMIMEType } from '../Interfaces/IMIMEType';
import { fileToBase64 } from '../Document/DocumentOverview';
import { DocumentPreviewDialog } from '../Document/DocumentAssistant/DocumentPreviewDialog';

interface IProps {
  invPaid: IInvoicePaid;
  invPaids: IInvoicePaid[];
  setInvPaids: Function;
  markNewPaids?: boolean;
}

export const InvoicePaidRow: React.FC<IProps> = ({
  invPaid,
  invPaids,
  setInvPaids,
  markNewPaids,
}) => {
  const thme = useTheme();

  const [editInvPaid, setEditInvPaid] = useState(invPaid);
  const mimeTypeArray = useSelector(
    (state: State) => state.mimeTypeArray.storeAcademicTitle
  );
  //
  const [localDocumentObject, setLocalDocumentObject] =
    useState<IDocument | null>(null);
  const [isOpenPreview, setisOpenPreview] = useState(false);

  const inputUpload = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setInvPaids([
      ...invPaids.map(paid =>
        paid.idInvoicePaid === editInvPaid.idInvoicePaid ? editInvPaid : paid
      ),
    ]);
  }, [editInvPaid]);

  const handleDownload = async () => {
    if (localDocumentObject !== null && localDocumentObject.Data) {
      base64Download(localDocumentObject, mimeTypeArray);
    } else {
      getFetch(
        '/document/',
        editInvPaid.idDocument,
        (localDocumentObject: IDocument) => {
          setLocalDocumentObject(localDocumentObject);
          base64Download(localDocumentObject, mimeTypeArray);
        }
      );
    }
  };

  const handleOpenPreview = () => {
    if (localDocumentObject === null || !localDocumentObject.Data) {
      getFetch('/document/', editInvPaid.idDocument, setLocalDocumentObject);
    }
    setisOpenPreview(true);
  };

  const handleFilesUpload = async (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      const currentFile = acceptedFiles[0];
      const fileName: string = String(currentFile['name']);
      const mimeType: IMIMEType | undefined = mimeTypeArray.find(
        mimeType => mimeType.MIMEType === currentFile['type']
      );
      if (mimeType) {
        const document: IDocument = {
          idDocument: -1,
          FileName: fileName,
          idMIMEType: mimeType.idMIMEType,
          Data: await fileToBase64(currentFile),
          Created_at: new Date().toISOString(),
          isFromTemplate: false,
          idDocumentDirectory: -1,
          idLegalTransaction: -1,
          perEmail: false,
        };
        setLocalDocumentObject(document);
        setEditInvPaid({
          ...editInvPaid,
          idDocument: -1,
          DocumentObject: document,
        });
      }
    }
  };

  const handleNormalUpload = (files: null | FileList) => {
    if (files) {
      const acceptedFiles: File[] = Array.from(files);
      handleFilesUpload(acceptedFiles);
    }
  };

  const handleRemoveMe = () => {
    setInvPaids([
      ...invPaids.filter(
        inv => inv.idInvoicePaid !== editInvPaid.idInvoicePaid
      ),
    ]);
  };

  return (
    <>
      <input
        hidden
        ref={inputUpload}
        type='file'
        accept={String(
          mimeTypeArray.map(mimeType => mimeType.MIMEType).join(', ')
        )}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          handleNormalUpload(event.target.files)
        }
      />
      <DocumentPreviewDialog
        open={isOpenPreview}
        localDocumentObject={localDocumentObject}
        onClose={() => setisOpenPreview(false)}
      />

      <TableRow
        sx={{
          backgroundColor:
            invPaid.idInvoicePaid > 0 ||
            markNewPaids === undefined ||
            markNewPaids === false
              ? undefined
              : alpha(thme.palette.success.light, 0.1),
        }}
      >
        <TableCell>
          <CustomeTextField
            attr='PaidDate'
            label=''
            object={invPaid}
            setObject={setEditInvPaid}
            type='date'
            required
          />
        </TableCell>
        <TableCell>
          <CustomeTextField
            attr='PaidValue'
            label=''
            object={invPaid}
            setObject={setEditInvPaid}
            type='euro'
            required
          />
        </TableCell>
        <TableCell>
          {editInvPaid.idDocument === null ? (
            <IconButton
              size='small'
              onClick={() => inputUpload && inputUpload.current?.click()}
            >
              <UploadFile />
            </IconButton>
          ) : (
            <>
              <IconButton size='small' onClick={handleOpenPreview}>
                <FindInPage />
              </IconButton>
              <IconButton size='small' onClick={handleDownload}>
                <Download />
              </IconButton>
            </>
          )}
          <IconButton size='small' onClick={handleRemoveMe}>
            <Delete />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
};
